import { LookupBase, NeoModel } from '@singularsystems/neo-core';

@NeoModel
export default class CommissionTypeLookup extends LookupBase {

    public commissionTypeId: number = 0;

    public commissionTypeName: string = "";

    // Client only properties / methods
}